import {
  Animations,
  Colors,
  Images,
  Metrics,
  Typography,
} from "../../resources";
import { ErrorType, SIconType } from "../../types";
import { ImageBackground, StyleSheet, Text, View } from "react-native";
import { SButton, SIcon } from "../atoms";

import Lottie from "lottie-react-web";
import React from "react";
import SSpacer from "../atoms/SSpacer";
import { noop } from "lodash";
import { useLocalStorage } from "../../hooks";

interface IProps {
  title: string;
  subtitle: string;
  description?: string | null;
  resetErrorBoundary?: () => void;
  type: ErrorType | string;
}

const SError: React.FC<IProps> = ({
  title,
  subtitle,
  description = null,
  type,
  resetErrorBoundary = noop,
}) => {
  const { clear } = useLocalStorage();
  const reset = () => {
    window.location.assign(window.location.origin);
    clear();
    resetErrorBoundary();
  };

  const iconType = () => {
    switch (type) {
      case ErrorType.API_NOT_REACHABLE:
        return SIconType.ErrorServer;
      case ErrorType.API_NO_CAMPUS:
        return SIconType.ErrorUnexpected;
      case ErrorType.API_UNAUTHORIZED:
        return SIconType.ErrorAuth;
      case ErrorType.AUTH:
        return SIconType.ErrorAuth;
      case ErrorType.HANDLED:
        return SIconType.ErrorUnexpected;
      case ErrorType.NETWORK:
        return SIconType.ErrorNetwork;
      case ErrorType.TIMEOUT:
        return SIconType.ErrorServer;
      default:
        return SIconType.ErrorUnexpected;
    }
  };

  return (
    <View style={styles.container}>
      <ImageBackground source={{ uri: Images.error }} style={styles.image}>
        <View style={styles.textContainer}>
          <SIcon
            type={iconType()}
            color={Colors.blue700}
            size={Metrics.iconSuperLarge}
          />
          <SSpacer space={Metrics.padding24} />
          <Text style={styles.title}>{title}</Text>
          <SSpacer space={Metrics.padding24} />
          <Text style={styles.subtitle}>
            {type === ErrorType.HANDLED ? subtitle : description}
          </Text>
          <SSpacer space={Metrics.padding24} />
          {/* {type ? (
            <>
              <Text style={styles.description}>{type}</Text>
              <SSpacer space={Metrics.paddingMedium} />
            </>
          ) : null} */}
          <SButton onPress={reset}>Reload Page</SButton>
        </View>
      </ImageBackground>
    </View>
    //       <View style={styles.container}>
    //    <Lottie
    //      width={Metrics.sizeSuperLarge}
    //      height={Metrics.sizeSuperLarge}
    //      options={{
    //        animationData: Animations.mouse,
    //      }}
    //    />
    //    <View style={styles.textContainer}>
    //      <SSpacer space={Metrics.paddingMedium} />
    //      <Text style={styles.title}>{title}</Text>
    //      <SSpacer space={Metrics.paddingMedium} />
    //      <Text style={styles.subtitle}>{subtitle}</Text>
    //      <SSpacer space={Metrics.paddingMedium} />
    //      {description ? (
    //        <>
    //          <Text style={styles.description}>{description}</Text>
    //          <SSpacer space={Metrics.paddingMedium} />
    //        </>
    //      ) : null}
    //      <SButton onPress={reset}>Reload Page</SButton>
    //    </View>
    //  </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  textContainer: {
    alignItems: "center",
  },
  title: {
    ...Typography.headline3,
    color: Colors.midnight,
  },
  subtitle: {
    ...Typography.body1,
    color: Colors.midnight,
  },
  description: {
    ...Typography.body1,
    color: Colors.midnight,
  },
});

export default SError;
